import Dialog from 'preact-material-components/Dialog';
import { connect } from 'react-redux';
import style from './style.css';
import limitCheckInfo from './limitCheckInfo';
import { closeLimitCheckModal } from '../../../../../actions/onLimitCheck';

const OnLimitCheckModal = (props) => {
  const { lenderId, lenderLogo, closeLimitCheckModal, userMobileNum } =
    props || {};
  const selectedLenderInfo = limitCheckInfo[lenderId];

  return (
    <div>
      <div className={style.closeIconContainer}>
        <img
          src='https://iccdn.in/img/widget-img/widget-close-overlay.svg'
          alt='close'
          id='close-button'
          className={style.closeIcon}
          onClick={() => {
            closeLimitCheckModal();
          }}
        />
      </div>

      <div className={style.lenderLogoContainer}>
        <img src={lenderLogo} alt={'lender logo'} />
      </div>

      <Dialog.Body>
        {selectedLenderInfo ? (
          <div>
            <div className={`${style.checkLimitText} text-center  font18`}>
              To check your limit, send <b>SMS</b>
            </div>
            <div
              style={{ color: '#227ae0' }}
              className={`text-center bold-text font20`}>
              {selectedLenderInfo.text}
            </div>
            <div className={style.checkLimitPromptText}>
              to <b>{selectedLenderInfo.number}</b> from your registered number
              ending in <b>{userMobileNum.slice(-4)}</b>
            </div>
          </div>
        ) : (
          <div
            className={`${style.checkLimitText} text-center bold-text font18`}>
            You'll be able to check your limit soon
          </div>
        )}
      </Dialog.Body>
    </div>
  );
};

const mapStateToProps = ({ modal }) => {
  const { limitCheck } = modal || {};
  const { lenderId, lenderLogo, userMobileNum } = limitCheck;

  return {
    lenderId,
    lenderLogo,
    userMobileNum,
  };
};
export default connect(
  mapStateToProps,
  { closeLimitCheckModal },
)(OnLimitCheckModal);



// WEBPACK FOOTER //
// ./components/partial/layers/modals/onLimitCheckModal/index.js